var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "product-type"
  }, [(_vm.bundle) ? [_vm._v(_vm._s(_vm.$t('types.bundle')))] : [_vm._v(_vm._s(_vm.$t('types.standard')))]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6576c29e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductType.vue
// module id = 2025
// module chunks = 0